<template>
  <div class="">
    <Modal
      v-model="isShowModal"
      width="600"
      :title="storageTitle"
      :mask-closable="false"
      :loading="loading"
      @on-ok="sumbit('storageForm')"
    >
      <Form
        ref="storageForm"
        :model="storageForm"
        :rules="ruleValidate"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="CorpID" prop="corpid" label-for="corpid">
          <Input
            disabled
            placeholder="请输入CorpID"
            element-id="corpid"
            v-model="storageForm.corpid"
          ></Input>
        </FormItem>
        <FormItem label="充值存储数量" prop="num" label-for="num">
          <Input
            placeholder="请输入充值存储数量"
            element-id="num"
            v-model="storageForm.num"
          >
            <div slot="append">G</div>
          </Input>
        </FormItem>
        <FormItem label="充值金额" prop="amount" label-for="amount">
          <Input
            placeholder="请输入充值金额"
            element-id="amount"
            v-model="storageForm.amount"
          ></Input>
        </FormItem>
        <FormItem label="过期时间" prop="expire_time">
          <SmyDatePicker
            transfer
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择过期时间"
            style="width: 100%"
            :options="dateDisabledOptions"
            :value="storageForm.expire_time"
            @input="storageForm.expire_time = $event"
          />
        </FormItem>
        <FormItem label="充值备注" prop="remark" label-for="remark">
          <Input
            placeholder="请输入充值备注"
            element-id="remark"
            v-model="storageForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import SmyDatePicker from '@/components/SmyDatePicker'
export default {
  name: 'StorageModal',
  components: {
    SmyDatePicker,
  },
  props: {
    agentId: {
      type: Number,
    },
    storageTitle: {
      type: String,
    },
    storageModal: {
      type: Boolean,
      required: true,
    },
    storageRow: {
      type: Object,
    },
  },
  data() {
    const validateNumber = (rule, value, callback) => {
      if (!value.match(/^\d+$/)) {
        callback(new Error('只能输入数字'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      visible: false,
      isShowModal: this.storageModal,
      storageForm: {
        corpid: '',
        epId: '',
        num: '',
        amount: '',
        remark: '',
        expire_time: ''
      },
      ruleValidate: {
        corpid: [
          { required: true, message: 'corpid不能为空', trigger: 'blur' },
        ],
        num: [
          { required: true, message: '充值短信数量不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '充值金额不能为空', trigger: 'blur' },
        ],
        expire_time: [
          { required: true, message: '请选择过期时间', trigger: 'change' },
        ],
      },
      // 日期配置 （无法选择今日之前的日期）
      dateDisabledOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000
        },
      },
    }
  },
  methods: {
    // 保存编辑数据
    sumbit(val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.storageForm,
          }
          let url = '/enterprise/mgr/addStorage'
          this.$http.post(url, data).then((res) => {
            if (res.success) {
              let msg = '操作成功'
              this.$Message.success(msg)
              this.isShowModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload() {
      this.agentId = this.storageRow.id
      this.storageForm.epId = this.storageRow.id
      this.storageForm.corpid = this.storageRow.corpid
    },
  },
  watch: {
    storageModal(val) {
      this.isShowModal = val
      if (val) {
        this.reload()
      }
    },
    isShowModal(val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/StorageModal.vue